import { Injectable } from '@angular/core';
import { first, Observable, Subject } from 'rxjs';
import { PacedCourseOffering } from 'src/app/models/paced-course-offering';

@Injectable()
export class PacedCourseOfferingActionsService {
  private addPacedCourseOfferingAction = new Subject<void>();
  private editPacedCourseOfferingAction = new Subject<PacedCourseOffering>();
  private deletePacedCourseOfferingAction = new Subject<PacedCourseOffering>();
  private editPacedCourseOfferingTutorRoleAction = new Subject<PacedCourseOffering>();
  private refreshPacedCourseOfferingAction = new Subject<void>();
  private refreshCompleteAction = new Subject<void>();

  addPacedCourseOffering$ = this.addPacedCourseOfferingAction.asObservable();
  editPacedCourseOffering$ = this.editPacedCourseOfferingAction.asObservable();
  deletePacedCourseOffering$ = this.deletePacedCourseOfferingAction.asObservable();
  editPacedCourseOfferingTutorRole$ =
    this.editPacedCourseOfferingTutorRoleAction.asObservable();
  refreshPacedCourseOfferings$ = this.refreshPacedCourseOfferingAction.asObservable();
  refreshComplete$ = this.refreshCompleteAction.asObservable();

  constructor() {}

  requestPacedCourseOfferingAdd(): Observable<void> {
    return new Observable<void>((observer) => {
      this.addPacedCourseOfferingAction.next();

      this.refreshComplete$.pipe(first()).subscribe(() => {
        observer.next();
        observer.complete();
      });
    });
  }

  requestPacedCourseOfferingEdit(pe: PacedCourseOffering) {
    this.editPacedCourseOfferingAction.next(pe);
  }

  requestPacedCourseOfferingDelete(pe: PacedCourseOffering) {
    this.deletePacedCourseOfferingAction.next(pe);
  }

  requestPacedCourseOfferingTutorRoleEdit(pe: PacedCourseOffering) {
    this.editPacedCourseOfferingTutorRoleAction.next(pe);
  }

  requestPacedCourseOfferingsRefresh() {
    this.refreshPacedCourseOfferingAction.next();
  }

  notifyRefreshComplete() {
    this.refreshCompleteAction.next();
  }
}
